import { gql } from '@apollo/client';

export default gql`
  query timetableServicesDisruptions($date: Date!, $originUic: String, $destinationUic: String) {
    timetableServices(date: $date, originUic: $originUic, destinationUic: $destinationUic) {
      model {
        trainNumber
        carrier
      }
      news {
        model {
          id
          title {
            ...disruptionTranslations
          }
          description {
            ...disruptionTranslations
          }
          commercial {
            ...disruptionTranslations
          }
        }
        snRelation {
          status
          delay
        }
      }
      serviceStops {
        model {
          isDeparted
          commercialDepartureDateTime
          scheduledDepartureDateTime
          expectedDepartureDateTime
        }
        station {
          uic
        }
      }
    }
  }

  fragment disruptionTranslations on TimetableTranslations {
    en
    fr
    de
    nl
  }
`;
